export default {

	sameDay: function (day1, day2) {
		return day1.getFullYear() === day2.getFullYear() && day1.getDate() === day2.getDate() && day1.getMonth() === day2.getMonth();
	},

	ordinal: function (i) {
		var j = i % 10,
			k = i % 100;
		if (j === 1 && k !== 11) {
			return "st";
		}
		if (j === 2 && k !== 12) {
			return "nd";
		}
		if (j === 3 && k !== 13) {
			return "rd";
		}
		return "th";
	}

}



/** WEBPACK FOOTER **
 ** ./site/sites/all/themes/custom/abr_theme/js/race-schedule/util.js
 **/